import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import {
  GROUP_NAME_CASE_SENS,
  GROUP_NAME_SSO,
  GROUP_NAME_SYNC
} from './usePwdUserSettingsMultipleEndpoint';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';

const useSaveAtMultipleEndpoint = () => {
  const { isLoading, mutate: mutateNameSync } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: 24,
    invalidateQueryKey: [GROUP_NAME_SYNC]
  });

  const { isLoading: isSSOLoading, mutate: mutateSSO } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: 16,
    invalidateQueryKey: [GROUP_NAME_SSO]
  });

  const { isLoading: isNameCaseLoading, mutate: mutateNameCase } =
    useUpdateResource({
      url: ADMIN_SETTINGS_GROUP,
      id: 21,
      invalidateQueryKey: [GROUP_NAME_CASE_SENS]
    });

  return {
    isLoading: isLoading || isSSOLoading || isNameCaseLoading,
    mutateNameCase,
    mutateNameSync,
    mutateSSO
  };
};

export default useSaveAtMultipleEndpoint;
